export function findBaskets(collection, items) {
    const current = new Set(items)
    return collection.filter(
        (basket) => basket.children.length === items.length && basket.children.every((c) => current.has(c._id))
    )
}
